import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AdminService } from '../services/admin.service';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.css'],
  standalone: false
})
export class AdminLoginComponent implements OnInit {
  loginForm: FormGroup;
  isLoading = false;
  loginError = '';
  hidePassword = true;

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  ngOnInit(): void {
    // Rediriger si déjà connecté
    if (this.adminService.isAdmin()) {
      this.router.navigate(['/admin/dashboard']);
    }
  }

  async onSubmit(): Promise<void> {
    if (this.loginForm.invalid) {
      return;
    }

    this.isLoading = true;
    this.loginError = '';

    try {
      const email = this.loginForm.value.email;
      const password = this.loginForm.value.password;

      await this.adminService.adminLogin(email, password);
      this.snackBar.open('Connexion réussie', 'Fermer', { duration: 3000 });
      this.router.navigate(['/admin/dashboard']);
    } catch (error) {
      console.error('Erreur de connexion:', error);
      
      // Gérer les différents types d'erreurs
      if (error.message && error.message.includes('droits d\'administration')) {
        this.loginError = 'Vous n\'avez pas les droits administrateur. Seuls les comptes autorisés peuvent accéder à cette section.';
      } else if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
        this.loginError = 'Email ou mot de passe incorrect';
      } else if (error.code === 'auth/too-many-requests') {
        this.loginError = 'Trop de tentatives échouées. Veuillez réessayer plus tard.';
      } else {
        this.loginError = 'Une erreur s\'est produite lors de la connexion';
      }
      
      this.snackBar.open('Échec de connexion: ' + this.loginError, 'Fermer', { duration: 5000 });
    } finally {
      this.isLoading = false;
    }
  }
}
